import config from '@/config';
import {
  GameContentServiceError,
  GameContentService,
  CanDoAnswersResponse,
  UnitsTopicsResponse,
  TopicsActivitiesResponse,
} from '@/school-management/types/services/gameContent';
import axiosInstance from '@/school-management/utils/api';
import { AxiosError } from 'axios';

const createGameContentServiceError = (error: any): GameContentServiceError => {
  const axiosError = error as AxiosError;
  const status = axiosError.response?.status || 500;
  const responseData = axiosError.response?.data as any;

  const message = responseData?.message || axiosError.message || 'An unexpected error occurred';
  const code = responseData?.code || `HTTP_${status}`;

  const url = axiosError.config?.url;

  const gameContentServiceError: GameContentServiceError = {
    code,
    message,
    statusCode: status,
    url,
    details: responseData?.details || responseData,
  };

  return gameContentServiceError;
};

export const gameContentService: GameContentService = {
  getCanDoAnswers: async (fromToLanguage: string): Promise<CanDoAnswersResponse | null> => {
    try {
      const url = `/${config.apiVersion}/${fromToLanguage}/settings/can-do-answers`;
      const resp: CanDoAnswersResponse | null = await axiosInstance.get(url);

      return resp;
    } catch (error: any) {
      const gameContentServiceError = createGameContentServiceError(error);
      console.error('Error fetching CanDoAnswers:', gameContentServiceError);
      throw gameContentServiceError;
    }
  },

  getUnitTopics: async (
    fromToLanguage: string,
    level: number | string,
    unitId: number | string
  ): Promise<UnitsTopicsResponse | null> => {
    try {
      const url = `/${config.apiVersion}/${fromToLanguage}/game-content/${level}/${unitId}`;
      const resp: UnitsTopicsResponse | null = await axiosInstance.get(url);

      return resp;
    } catch (error: any) {
      const gameContentServiceError = createGameContentServiceError(error);
      console.error('Error fetching UnitsTopics:', gameContentServiceError);
      throw gameContentServiceError;
    }
  },

  getTopicActivities: async (
    fromToLanguage: string,
    level: number | string,
    unitId: number | string,
    topicId: number | string
  ): Promise<TopicsActivitiesResponse | null> => {
    try {
      const url = `/${config.apiVersion}/${fromToLanguage}/game-content/${level}/${unitId}/${topicId}`;
      const resp: TopicsActivitiesResponse | null = await axiosInstance.get(url);

      return resp;
    } catch (error: any) {
      const gameContentServiceError = createGameContentServiceError(error);
      console.error('Error fetching TopicActivities:', gameContentServiceError);
      throw gameContentServiceError;
    }
  },
};
